<template>
  <div class="row">
    <div class="col-xs-12">
      <form @submit.prevent="handleSubmit">
        <register-input
          componentID="user-first-name"
          :label="$t('full name')"
          inputType="text"
          :inputPlaceholder="$t('full name')"
          :isRequired="true"
          class="form__input"
          v-model="form.full_legal_name"
        />
        <register-input
          componentID="user-iin"
          :label="$t('bin')"
          :inputPlaceholder="$t('bin')"
          :isRequired="true"
          class="form__input"
          :inputMaxLength="12"
          v-model="form.bin"
        />
        <p
          class="login-form__error"
          v-if="form.bin.length == 12 && !validateIin(form.bin)"
        >
          {{ $t("incorrect bin") }}
        </p>
        <div class="input-container">
          <label for="user-phone" class="label">
            {{ $t("mobile number") }}
            <span class="form__red">*</span>
          </label>
          <input
            type="tel"
            class="input"
            :placeholder="$t('mobile number')"
            required
            maxlength="16"
            id="user-phone"
            v-model="form.phone_number"
            @keyup="formatPhone"
            @blur="formatPhone"
          />
        </div>
        <br />
        <register-input
          componentID="user-email"
          :label="$t('email address')"
          inputType="email"
          :inputPlaceholder="$t('email address')"
          class="form__input"
          :isRequired="true"
          v-model="form.email"
        />
        <!--        <div class="form__rules-confirm">-->
        <!--          <input-->
        <!--            v-model="rulesAccepted"-->
        <!--            type="checkbox"-->
        <!--            class="form__checkbox"-->
        <!--            id="confirm-checkbox"-->
        <!--          />-->
        <!--          <span class="form__rules-label">-->
        <!--            Даю согласие на обработку персональных данных, на использование-->
        <!--            обезличенных персональных данных в коммерческих целях-->
        <!--          </span>-->
        <!--        </div>-->
        <button class="button filled form__button">{{ $t("confirm") }}</button>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

import RegFormMixin from "../form_mixin";
export default {
  data() {
    return {
      form: {
        full_legal_name: "",
        bin: "",
        phone_number: "",
        email: ""
      }
    };
  },
  mixins: [RegFormMixin],
  methods: {
    ...mapActions(["register"]),
    validateIin() {
      let s = 0;
      let i = 0;
      let k = 0;
      let t = 0;

      for (i = 0; i < 11; i++) {
        s = s + (i + 1) * this.form.bin[i];
      }

      k = s % 11;

      if (k == 10) {
        s = 0;

        for (i = 0; i < 11; i++) {
          t = (i + 3) % 11;

          if (t == 0) {
            t = 11;
          }

          s = s + t * this.form.bin[i];
        }

        k = s % 11;

        if (k == 10) {
          return false;
        }
      }
      return k == this.form.bin.substring(11, 12);
    },
    formatPhone() {
      let num = this.form.phone_number.replace(/\D/g, "").split(/(?=.)/);
      let i = num.length - 1;
      if (0 <= i) num.unshift("+");
      if (1 <= i) num.splice(2, 0, " ");
      if (4 <= i) num.splice(6, 0, " ");
      if (7 <= i) num.splice(10, 0, "-");
      if (9 <= i) num.splice(13, 0, "-");
      this.form.phone_number = num.join("");
    },
    registerAction() {
      this.$toasted.clear();
      this.$toasted.show(this.$t("loading"), { duration: 100000 });
      let data = {
        bin: this.form.bin,
        company_name: this.form.full_legal_name,
        phone: this.form.phone_number,
        email: this.form.email,
        is_legal: true
      };
      // console.log(data);
      this.register(data).then(res => {
        this.$toasted.clear();
        if (res.data.status) {
          this.$toasted.success(this.$t("data sent"));
          this.$router.push("/auth/register/basic-thank");
        } else {
          this.$toasted.clear();
          this.$toasted.error(this.$t("error"));
          if (res.data.result.errors) {
            Object.entries(res.data.result.errors).forEach(error => {
              console.log(error);
              this.$toasted.show(this.$t("incorrect form format"), {
                duration: 5000
              });
            });
          }
        }
      });
    },
    handleSubmit() {
      if (this.validateIin()) {
        this.registerAction();
      } else {
        this.$toasted.error(this.$t("incorrect bin"));
      }
    }
  }
};
</script>
